<template>
<div class="chapter">
<div class="inner_page">
<p class="normalb-1"><span>In <i>The Biology of Sin</i>, Matthew Stanford probes the fascinating interface between the spirit and the brain in ways that are sure to intrigue and stimulate those who are interested in how Christian faith can inform our understanding of a fallen corporeal nature. I enthusiastically recommend this book to all Christians who are curious about science.</span></p>
<p class="normalb1a"><span><i>Jeffrey M. Schwartz, M.D.</i><br/>
<i>Research psychiatrist, UCLA School of Medicine and author of</i> The Mind and the Brain: Neuroplasticity and the Power of Mental Force</span></p>
<p class="normalb-2"><span>Sin doesn’t occur in a vacuum. We sin by choice, but our choices are often guided by inclinations that we often don’t understand. Dr. Stanford has provided a valuable resource to the church by integrating a wide range of research on the biological conditions associated with various kinds of sins together with Scriptural teaching on these problems and how to address them. Avoiding the extremes of moralism and determinism, he takes seriously both human responsibility and biological vulnerabilities. Peppered with case studies, this book will be helpful to pastors, laypeople, and counselors seeking a better understanding of this complex area of human life.</span></p>
<p class="normalb1a"><span><i>Eric L. Johnson, Ph.D.</i><br/>
<i>Lawrence and Charlotte Hoover Professor of Pastoral Care, Southern Baptist Theological Seminary and author of</i> Foundations for Soul Care: A Christian Psychology Proposal</span></p>
<p class="normalb-2"><span>In years of trying to help people through the complex issues of their brokenness, I’ve longed for resources to help explain the power of innate sin in a person’s life. Thank you, Matt, for integrating biology and brokenness so we can help set people free from the pains and struggles of their lives.</span></p>
<p class="normalb1a"><span><i>Jimmy Seibert<br/>
  Pastor, Antioch Community Church (Waco, TX) and author of</i> The Church Can Change the World: Living from the Inside Out</span></p>
<p class="normalb-2"><span>We both love how Matthew has taken the concept of sin and given a breath of fresh air to the topic. You must read this book because in its pages you will finally gain a biblical perspective on sin and what it takes to free yourself from the bonds that so easily entangle!</span></p>
<p class="normalb1a"><span class="sgc-1">Gary and Michael Smalley<br/>
  Smalley Relationship Center</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?eba75d10